import React from 'react';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import backgroundImageFromSalesforce from '../../Assets/welcomPic.jpg'

function DashboardContent() {

  const userName = sessionStorage.getItem("userName") ? sessionStorage.getItem("userName") : "Buddy!";


  return (
    <>
    <Dashboard_Comp>
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
              <Grid item xs={8} md={8} lg={8}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    height: 370
                  }}
                >
                  <h1 style={{ position: "absolute", width: "94.9%", textAlign: "center", marginTop: "10px", backgroundColor: "#222222", color: "white" }} ><i>Welcome {userName}</i></h1>
                  <Box
                      component="img"
                      sx={{
                        height: 340,
                        width: "100%"
                      }}
                      alt="Welcome Pic."
                      src={backgroundImageFromSalesforce}
                    />
                </Paper>
              </Grid>
            </Grid> 
          </Container>
    </Dashboard_Comp>
    </>
  )
}

export default DashboardContent;